import React from 'react';
import PuffLoader from 'react-spinners/PuffLoader';
import S from './LoadingOverlay.styles';
const LoadingOverlay = () => {
    return (React.createElement(S.Container, null,
        React.createElement(PuffLoader, { color: "#fff", size: 96 })));
};
export default LoadingOverlay;
